import { merge } from 'lodash';
import { bigQuery } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { BASE_BIG_QUERY_PARAMS } from '../../../utils/reporter/constants';
import { type BigQueryEventName } from './bigQuery.types';

const createBigQueryReporter = () => {
    const send = (name: BigQueryEventName, data: Record<string, string> = {}) => {
        const { pageCtxId } = getContext();

        const page = {
            ctx_id: pageCtxId,
        };

        const eventPayload = merge({ page }, BASE_BIG_QUERY_PARAMS, data);

        bigQuery.send({
            type: name,
            ...eventPayload,
        });
    };

    return {
        send,
    };
};

export const globalBigQueryReporter = createBigQueryReporter();
